import React from 'react';
import { IconChartCohort } from '@tabler/icons-react';

/**
 * Item do menu ⋯ que abre o modal de visualização técnica.
 */
export function BoardTechnicianViewSubmenu({ onOpen }) {
  return (
    <button
      type="button"
      className="refresh-context-menu-item"
      onClick={() => onOpen?.()}
    >
      <span className="refresh-context-menu-item-main">
        <IconChartCohort size={16} stroke={1} aria-hidden />
        <span>Visualização técnica</span>
      </span>
    </button>
  );
}

export default BoardTechnicianViewSubmenu;
